import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './service/ProtectedRoute';
import MainLayout from './layouts/MainLayout';
import HomePage from './views/HomePage';
import LoginPage from './views/auth/LoginPage';
import RegisterPage from './views/auth/RegisterPage';
import LogementList from './views/logements/LogementList';
import LogementDetail from './views/logements/LogementDetail';
import LogementForm from './views/logements/LogementForm';
import DemarcheSuivi from './views/demarches/DemarcheSuivi';
import GuidePage from './views/guide/GuidePage';
import CommunityPage from './views/community/CommunityPage';
import CommunityPostDetail from './views/community/CommunityPostDetail';
import CommunityForm from './views/community/CommunityForm';
import MessageriePage from './views/messages/MessageriePage';
import NotificationsPage from './views/notifications/NotificationsPage';
import FavoritesPage from './views/logements/FavoritesPage';
import LogementMap from './views/logements/LogementMap';
import MesLogements from './views/logements/MesLogements';
import ProfilePage from './views/profile/ProfilePage';
import StudentDashboard from './views/dashboard/StudentDashboard';
import OwnerDashboard from './views/dashboard/OwnerDashboard';
import AdminDashboard from './views/dashboard/AdminDashboard';
import ServiceAcadDashboard from './views/dashboard/ServiceAcadDashboard';

function HomeRouter() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <MainLayout>
        <div className="flex justify-center items-center min-h-[60vh]">
          <div className="animate-spin rounded-full h-8 w-8 border-2" style={{ borderColor: '#C59B6C', borderTopColor: 'transparent' }} />
        </div>
      </MainLayout>
    );
  }
  if (user) {
    const role = user.role;
    if (role === 'student' || role === 'owner' || role === 'admin' || role === 'service_acad') {
      return <Navigate to={`/dashboard/${role}`} replace />;
    }
  }
  return <MainLayout><HomePage /></MainLayout>;
}

function DashboardRedirect() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (user.role) {
    return <Navigate to={`/dashboard/${user.role}`} replace />;
  }
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeRouter />} />
      <Route path="/login" element={<MainLayout><LoginPage /></MainLayout>} />
      <Route path="/register" element={<MainLayout><RegisterPage /></MainLayout>} />
      <Route path="/logements" element={<MainLayout><LogementList /></MainLayout>} />
      <Route path="/logements/carte" element={<MainLayout><LogementMap /></MainLayout>} />
      <Route path="/logements/nouveau" element={
        <ProtectedRoute roles={['owner', 'admin']}>
          <MainLayout><LogementForm /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/logements/:id/editer" element={
        <ProtectedRoute roles={['owner', 'admin']}>
          <MainLayout><LogementForm /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/logements/:id" element={<MainLayout><LogementDetail /></MainLayout>} />
      <Route path="/guide" element={<MainLayout><GuidePage /></MainLayout>} />
      <Route path="/guide/:categorie" element={<MainLayout><GuidePage /></MainLayout>} />

      <Route path="/communautes" element={<MainLayout><CommunityPage /></MainLayout>} />
      <Route path="/communautes/nouveau" element={
        <ProtectedRoute>
          <MainLayout><CommunityForm /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/communautes/:id" element={<MainLayout><CommunityPostDetail /></MainLayout>} />

      <Route path="/favoris" element={
        <ProtectedRoute roles={['student']}>
          <MainLayout><FavoritesPage /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/mes-logements" element={
        <ProtectedRoute roles={['owner', 'admin']}>
          <MainLayout><MesLogements /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/profil" element={
        <ProtectedRoute>
          <MainLayout><ProfilePage /></MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/admin/utilisateurs" element={
        <ProtectedRoute roles={['admin']}>
          <MainLayout><AdminDashboard defaultSection="users" /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/admin/guide" element={
        <ProtectedRoute roles={['admin']}>
          <MainLayout><AdminDashboard defaultSection="guide" /></MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/demarches" element={
        <ProtectedRoute roles={['student', 'service_acad', 'admin']}>
          <MainLayout><DemarcheSuivi /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/notifications" element={
        <ProtectedRoute>
          <MainLayout><NotificationsPage /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/messages" element={
        <ProtectedRoute>
          <MainLayout><MessageriePage /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/messages/:userId" element={
        <ProtectedRoute>
          <MainLayout><MessageriePage /></MainLayout>
        </ProtectedRoute>
      } />

      <Route path="/dashboard" element={<DashboardRedirect />} />
      <Route path="/dashboard/student" element={
        <ProtectedRoute roles={['student']}>
          <MainLayout><StudentDashboard /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/dashboard/owner" element={
        <ProtectedRoute roles={['owner']}>
          <MainLayout><OwnerDashboard /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/dashboard/admin" element={
        <ProtectedRoute roles={['admin']}>
          <MainLayout><AdminDashboard /></MainLayout>
        </ProtectedRoute>
      } />
      <Route path="/dashboard/service_acad" element={
        <ProtectedRoute roles={['service_acad']}>
          <MainLayout><ServiceAcadDashboard /></MainLayout>
        </ProtectedRoute>
      } />

      <Route path="*" element={
        <MainLayout>
          <div className="page-container py-20 text-center">
            <h1 className="font-serif text-4xl font-bold text-navy mb-4">404</h1>
            <p className="text-navy/60">Page non trouvée</p>
          </div>
        </MainLayout>
      } />
    </Routes>
  );
}
